import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/image/home/device-check.png';
import _imports_1 from '@/assets/image/home/qrcode1.jpg';
var _withScopeId = function (n) {
  return _pushScopeId("data-v-a6e3559a"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "wrapper-container"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("img", {
    src: _imports_0,
    alt: "环境检测",
    class: "env-check-image"
  }, null, -1);
});
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "env-check-text"
  }, "设备检测", -1);
});
var _hoisted_4 = [_hoisted_2, _hoisted_3];
var _hoisted_5 = {
  key: 0,
  class: "btn-group"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "btn-text"
  }, "活动咨询", -1);
});
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("img", {
    class: "qrcode-image",
    src: _imports_1,
    alt: "活动通知"
  }, null, -1);
});
var _hoisted_8 = {
  class: "btn-item-notify"
};
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "btn-text"
  }, "活动通知", -1);
});
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("a", {
    href: "https://hetao101.com/"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "btn-hetao-site"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "btn-text"
  }, "核桃官网")])], -1);
});
var _hoisted_11 = {
  class: "btn-top-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_divider = _resolveComponent("a-divider");
  var _component_a_popover = _resolveComponent("a-popover");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "btn-env-check",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return _ctx.goToEnvCheck && _ctx.goToEnvCheck.apply(_ctx, args);
    })
  }, _hoisted_4), false ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", {
    class: "btn-item-consult zhichiButtonClass",
    onClickOnce: _cache[1] || (_cache[1] =
    //@ts-ignore
    function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return _ctx.initZhiChiFirstTime && _ctx.initZhiChiFirstTime.apply(_ctx, args);
    })
  }, [_hoisted_6, _createVNode(_component_a_divider)], 32), _createVNode(_component_a_popover, {
    placement: "left",
    overlayClassName: "popover-qrcode-image"
  }, {
    content: _withCtx(function () {
      return [_hoisted_7];
    }),
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_a_divider)])];
    }),
    _: 1
  }), _hoisted_10])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_11, [_withDirectives(_createElementVNode("div", {
    class: "btn-top",
    onClick: _cache[2] || (_cache[2] =
    //@ts-ignore
    function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return _ctx.goToTop && _ctx.goToTop.apply(_ctx, args);
    })
  }, "回到顶部", 512), [[_vShow, _ctx.visible]])])]);
}